<template>
  <b-modal title="Serviços do Equipamento" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE SERVIÇOS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getServicos" :fields="fields.servico">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(concluido)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ conclusao(data.item) }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="delServico(data.item)">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>

    <servico-edit-modal ref="servicoEdit" @update="update()" />
    <confirm-modal ref="confirmServico" :descricao="'Deseja realmente remover o serviço ?'" @executar="executar()" />

    <template #modal-footer>
      <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
        <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import TableFields from "@/tools/TableFields";
import Equipamento from "@/models/Equipamento";
import Servico from "@/models/Servico";
import ServicoModal from "@/components/modals/equipamento/ServicoModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal";

export default {
  name: "ServicoListModal",

  components: {
    "confirm-modal": ConfirmModal,
    "servico-edit-modal": ServicoModal,
  },

  data() {
    return {
      show: false,
      fields: new TableFields(),
      equipamento: new Equipamento(0, "", "", "", "", "", "", "", "", "", "", ""),
      servicos: [],
      servico: new Servico(0, "", new Date(), false, false),
    };
  },

  methods: {
    editar(servico) {
      servico.equipamento = this.equipamento;
      this.$refs.servicoEdit.call(servico);
    },

    adicionar() {
      let servico = new Servico(0, "", new Date(), false, false);
      servico.equipamento = this.equipamento;
      this.$refs.servicoEdit.call(servico);
    },

    delServico(servico) {
      this.servico.update(servico);
      this.$refs.confirmServico.call();
    },

    executar() {
      this.equipamentoStore.REMOVER_SERVICO(this.servico.id).then(() => {
        this.update();
      });
    },

    conclusao(servico) {
      if (servico.concluido) {
        return "Sim";
      } else {
        return "Não";
      }
    },

    update() {
      this.equipamentoStore.LISTAR_SERVICOS(this.equipamento.sgcq).then(() => {
        this.servico = new Servico(0, "", new Date(), false, false);
        this.servicos = this.getServicos;
      });
    },

    call(equipamento) {
      this.show = !this.show;
      this.equipamento = equipamento;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getServicos } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getServicos,
    };
  },
};
</script>

<style lang="scss" scoped></style>
